const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const weekdayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const fetchJSON = (url, config = {}) => {
  return fetch(url, Object.assign({}, getDefaultRequestConfig(), config)).then(response => {
    if (!response.ok) {
      throw response
    }
    return response.json()
  })
}
// for fetch product data
const fetchProductData = async (handle) => {  
  try {
    const [data, metafields] = await Promise.all([
      fetchJSON(`/products/${handle}.js`),
      fetchProductMetafieldData(handle),
    ])
    return {
      ...data,
      metafields,
    }
  } catch (e) {
    console.error(e)
  }
}
const fetchProductMetafieldData = (handle) => {
  try {
    return fetchJSON(`/products/${handle}?view=json`, {
      method: 'GET',
    })
  } catch (e) {
    console.error(e)
  }
}

function getProductLeadTime (productDataMetafields, quantity) {
    const LeadDate = productDataMetafields.available_date != null ? productDataMetafields.available_date : 'now'
    const currentDate = new Date(LeadDate)
  
    if (productDataMetafields.inventory_quantity >= quantity) {
      const available_leadtime = productDataMetafields.available_leadtime != null ? productDataMetafields.available_leadtime : '1-3 days'
      let msg1 = `Delivery available in ${available_leadtime}`;
      if(available_leadtime === '1-3 days') msg1 = `In stock & ready for delivery`;
      return {
        date: currentDate,
        message: msg1,
        shortMessage: msg1,
      }
    }
  
    if (!productDataMetafields.product_availability) return
    if (productDataMetafields.product_availability.length == 0) return
    
    const availabilityJson = productDataMetafields.product_availability
  
    let totalAvailable = productDataMetafields.inventory_quantity
    const nextAvailable = availabilityJson.find(productAvailability => {
      totalAvailable += parseInt(productAvailability.quantity)
      return totalAvailable >= quantity
    })
    return { 
      date: new Date(nextAvailable.date),
      message: `Delivery available in ${nextAvailable.leadtime}`,
      shortMessage: `Delivery available in ${nextAvailable.leadtime}`,
    }
}
function parseLeadTime (leadTimeObject) {
    const available_leadtime = '1-3 days'
    if (!leadTimeObject) {
      return {
        days: 0,
        weeks: 0,
        longMessage: `In stock & ready for delivery`,
        shortMessage: `In stock & ready for delivery`,
      }
    }
  
    const leadTime = leadTimeObject.date
    const currentDate = new Date()
    const diff = Math.ceil((leadTime.valueOf() - currentDate.valueOf()) / 86400000)
  
    if (diff <= 1) {
      return {
        weeks: 0,
        hideInfo: false,
        longMessage: `Delivery available in ${available_leadtime}`,
        shortMessage: `Delivery available in ${available_leadtime}`,
      }
    }
  
    const weeks = Math.ceil(diff / 7)
    const leadTimeWeeks = diff > 14 ? weeks : 2
  
    if (leadTimeObject.message) {
      return {
        weeks,
        hideInfo: true,
        longMessage: leadTimeObject.message,
        shortMessage: leadTimeObject.shortMessage,
      }
    }
  
    return {
      weeks,
      hideInfo: false,
      longMessage: `Delivery available in ${leadTimeWeeks}-${leadTimeWeeks + 2} weeks`,
      shortMessage: `Delivery available in ${leadTimeWeeks}-${leadTimeWeeks + 2} weeks`,
    }
}
function getLongestLeadTime (leadTimes) {
    leadTimes.sort((a, b) => {
      return b.date.valueOf() - a.date.valueOf()
    })
  
    return leadTimes[0]
}
function addDays (date, days) {
    const result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
}
async function getCartMaxQuantities () {
    const leadTimeObject = await fetchJSON(`/cart?view=lead-time`)
    return parseLeadTimeObject(leadTimeObject);
}
async function getProductMaxQuantity (productUrl) {
    const leadTimeObject = await fetchJSON(
      `${productUrl}${productUrl.indexOf('?') > -1 ? '&' : '?'}view=lead-time`,
    )
    return parseLeadTimeObject(leadTimeObject);
}

function parseLeadTimeObject(leadTimeObject) {
  if (!leadTimeObject) {
      return;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tenWeeks = new Date();
  tenWeeks.setDate(tenWeeks.getDate() + parseInt(window.theme.leadTimeMaxDays, 10));

  const parsedItems = {};

  for (const product in leadTimeObject) {
      if (leadTimeObject.hasOwnProperty(product)) {
          const productLeadTime = leadTimeObject[product];
          const { available, availability, cart } = productLeadTime;

          const totalAvailable = availability.reduce((total, delivery) => {
              const deliveryDate = new Date(delivery.date);
              if (deliveryDate > tenWeeks || deliveryDate < today) {
                  return total;
              }
              return total + parseInt(delivery.quantity, 10);
          }, available);

          const max = totalAvailable - cart;

          parsedItems[product] = { ...productLeadTime, totalAvailable, max };
      }
  }

  const current = window.theme.productMaxQuantities || {};
  window.theme.productMaxQuantities = { ...current, ...parsedItems };
  return window.theme.productMaxQuantities;
}

const updateProductLeadTime = (key, leadtime,id,leadtime2) => {
  const els = getElements(`.cart-item[data-key="${key}"] .psh-Item_LightingDelivery`)
  els.forEach( (el) => { if(el) el.innerHTML = leadtime });
  const proEls = getElement(`.prd-ProductOffers_Delivery[data-id="${id}"] .js-Product_Delivery`)
  if(proEls) {
    proEls.innerHTML = leadtime2;
    const note = proEls.parentElement && proEls.parentElement.querySelector('.prd-Delivery_StockNote');
    if (note) note.classList.add('is-visible');
  }
}
const updateCartLeadTime = (data) => {
  data.items.forEach(async (item) => {
    if (item.product_type == 'Disposal' || item.product_type == 'Swatch') return
    let currentMaxQuantities = window.theme.productMaxQuantities
    if(Object.keys(currentMaxQuantities).length === 0) currentMaxQuantities = await getProductMaxQuantity(item.url);
    if(currentMaxQuantities[item.id] === null) currentMaxQuantities = await getProductMaxQuantity(item.url);
    const productData = await fetchProductData(item.handle);
    let qtyValue = parseInt(item.quantity) + (productData.metafields.quantity_in_product ? productData.metafields.quantity_in_product : parseInt(1))
    if(currentMaxQuantities[item.id] != undefined && currentMaxQuantities[item.id].totalAvailable <= item.quantity || currentMaxQuantities[item.id] != undefined && qtyValue > currentMaxQuantities[item.id].totalAvailable) qtyValue = currentMaxQuantities[item.id].totalAvailable;
    let leadtime = parseLeadTime(getProductLeadTime(productData.metafields, item.quantity)).shortMessage
    let leadtime2 = parseLeadTime(getProductLeadTime(productData.metafields, qtyValue)).shortMessage
    updateProductLeadTime(item.key, leadtime,item.id,leadtime2)
  });
}